import { createFileRoute } from "@tanstack/react-router";
import { UploadChargerPhotos } from "~/components/upload-charger-photos";

export const Route = createFileRoute("/(authenticated)/laadpaal-fotos-uploaden/")({
  component: UploadChargerPhotos,
});
